/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./sprig";
 *   Alpine.data('sprig', sprig);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="sprig('selector')" />
 *
 * @param selector
 * @returns {{init(): void, el: null, selector: null}}
 */

export default (selector = null) => ({
  el: null,
  selector: selector,

  init() {
    this.$nextTick(() => {

      if (!this.selector) {
        return;
      }
      this.el = document.querySelector(this.selector);
      if (!this.el) {
        return;
      }

      /* The htmx variable will only be found on pages where
      *
      *   {% block scriptAdditions %}
            {{ sprig.script }}
          {% endblock %}
      *
      * has been included. Otherwise, exit this function.
      * */

      if (typeof htmx === 'undefined') {
        return;
      }
      htmx.on('htmx:beforeOnLoad', () => {
        this.el.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      });
    });
  }
});